<template>
  <div id="applets">
    <mycarousel></mycarousel>

    <div class="applets1">
        <p class="title">专业小程序定制开发，让小程序制作更简单</p>
        <ul>
            <li v-for="(item,index) in applets1" :key="index">
                <img :src="item.icon" alt="" class="wow animate__animated animate__slideInUp">
                <p class="listTitle wow animate__animated animate__slideInUp">{{item.title}}</p>
                <span v-for="(list,i) in item.pagelist" :key="i" class="wow animate__animated animate__slideInUp">{{list}}</span>
                <!-- <button class="wow animate__animated animate__slideInUp">立即咨询</button> -->
            </li>
        </ul>
    </div>

    <div class="applets2">
        <div class="applets2Box">
            <div class="appletsLeft">
                <p class="appletsTitle">紧抓微信60+个流量窗口</p>
                <p class="appletsSubtitle">7亿+用户选择小程序</p>
                <ul>
                    <li v-for="(item,index) in applets2" :key="index" @mouseover="changeApplets2Index=index" class="wow animate__animated animate__fadeInLeft">
                        <img :src="item.icon" alt="">
                        <div>
                            <p class="p1">{{item.title}}</p>
                            <p class="p2" v-show="changeApplets2Index==index">{{item.subtitle}}</p>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="appletsRight">
                <img src="@/assets/applets/applets2.png" alt="" class="wow animate__animated animate__fadeInRight">    
            </div>  
        </div>
    </div>

    <div class="applets3">
        <p class="title">小程序定制开发升级方案</p>
        <ul class="applets3Box">
            <li class="left wow animate__animated animate__fadeInUp">
                <p class="BoxTitle">非专业模板小程序<span>（未定制）</span></p>
                <p class="BoxList wow animate__animated animate__fadeInUp" data-wow-delay="1s">数据紊乱 保密性差</p>
                <p class="BoxList wow animate__animated animate__fadeInUp" data-wow-delay="1s">模板性质 功能受限</p>
                <p class="BoxList wow animate__animated animate__fadeInUp" data-wow-delay="1s">界面布局死板 难以修改</p>
                <p class="BoxList wow animate__animated animate__fadeInUp" data-wow-delay="1s">功能固定 不能开发</p>
            </li>
            <li class="center">
                <img src="@/assets/applets/applets3.png" alt="">
            </li>
            <li class="right wow animate__animated animate__fadeInUp">
                <p class="BoxTitle">专业定制个性化小程序</p>
                <div>
                    <p class="BoxList wow animate__animated animate__fadeInUp" data-wow-delay="1s">数据整齐易分析</p>
                    <p class="BoxList wow animate__animated animate__fadeInUp" data-wow-delay="1s">界面设计随心所欲</p>
                    <p class="BoxList wow animate__animated animate__fadeInUp" data-wow-delay="1s">内部功能随心定制</p>
                    <p class="BoxList wow animate__animated animate__fadeInUp" data-wow-delay="1s">微信接口对接方便</p>
                    <p class="BoxList wow animate__animated animate__fadeInUp" data-wow-delay="1s">多种功能定制提高体验</p>
                    <p class="BoxList wow animate__animated animate__fadeInUp" data-wow-delay="1s">全面配合营销推广</p>
                    <p class="BoxList wow animate__animated animate__fadeInUp" data-wow-delay="1s">后台数据一览无余</p>
                    <p class="BoxList wow animate__animated animate__fadeInUp" data-wow-delay="1s">数据保密性极高</p>
                </div>
            </li>
        </ul>
        <ul class="appletsBox2 wow animate__animated animate__fadeInUp">
            <button>升级前</button>
            <img src="@/assets/applets/applets3icon1.png" alt="">
            <button>升级后</button>
        </ul>
        <ul class="appletsBox3">
            <li v-for="(item,index) in applets3" :key="index" :data-wow-delay="index/2+'s'" class="wow animate__animated animate__fadeInUp">
                <p :class="['BoxTitle','BoxTitle'+(index+1)]">{{item.title}}</p>
                <p class="BoxSubtitle" v-html="item.subtitle"></p>
            </li>
        </ul>
    </div>

    <div class="applets4">
        <ul class="wow animate__animated animate__fadeInLeft">
            <li class="left">
                <p class="title">完美对接微信后台，一站式服务</p>
                <p class="subtitle">客服全程一对一指导注册登录，保证您的数据安全性，保证您的使用流畅性，保证为您提供最佳的体验感。</p>
                <!-- <div>
                    <button class="button1">立即咨询</button>
                    <button class="button2">申请试用</button>
                </div> -->
            </li>
            <li><img src="@/assets/applets/applets4.png" alt=""></li>
        </ul>
    </div>

    <mytechnology></mytechnology>
  </div>
</template>

<script>
import mycarousel from  '@/components/carousel/carousel.vue'
import mytechnology from  '@/components/technology/technology.vue'
export default {
    components: {
        mycarousel,
        mytechnology
    },
    data(){
        return {
            changeApplets2Index:0,
            applets1:[
                {
                    icon:require('@/assets/applets/applets1icon1.png'),
                    title:"企业小程序定制",
                    pagelist:['全行业覆盖','各行各业可定制','开发效率极高']
                },
                {
                    icon:require('@/assets/applets/applets1icon2.png'),
                    title:"小程序界面设计",
                    pagelist:['精美页面设计','组块化按需定制','页面整洁干净']
                },
                {
                    icon:require('@/assets/applets/applets1icon3.png'),
                    title:"小程序后台管理",
                    pagelist:['客服帮助上线','接口数据对接','客服1对1指导']
                },
                {
                    icon:require('@/assets/applets/applets1icon4.png'),
                    title:"小程序信息保密",
                    pagelist:['数据保密协议','客户信息绝对保密','后台尽在您手']
                }
            ],
            applets2:[
                {
                    icon:require('@/assets/applets/applets2icon1.png'),
                    title:"一扫直达页面",
                    subtitle:"轻松获取页面路径链接及二维码"
                },
                {
                    icon:require('@/assets/applets/applets2icon2.png'),
                    title:"搜索小程序",
                    subtitle:"设置页面关键词，占位微信搜索"
                },
                {
                    icon:require('@/assets/applets/applets2icon3.png'),
                    title:"附近的小程序",
                    subtitle:"覆盖5公里内，为线下门店引流"
                },
                {
                    icon:require('@/assets/applets/applets2icon4.png'),
                    title:"公众号跳转小程序",
                    subtitle:"小程序关联公众号，促导流转化"
                },
                {
                    icon:require('@/assets/applets/applets2icon5.png'),
                    title:"分享小程序",
                    subtitle:"自定义分享样式，实现裂变分享"
                },
                {
                    icon:require('@/assets/applets/applets2icon6.png'),
                    title:"小程序互相跳转",
                    subtitle:"实现场景互补、服务延伸"
                },
                {
                    icon:require('@/assets/applets/applets2icon7.png'),
                    title:"朋友圈广告",
                    subtitle:"利用优惠活动高效促进到店消费"
                },
                {
                    icon:require('@/assets/applets/applets2icon8.png'),
                    title:"最近使用列表",
                    subtitle:"提高小程序露出率及用户粘性"
                },
            ],
            applets3:[
                {
                    title:'资深运营团队',
                    subtitle:"资深运营团队遍布全国<br/>提供系统配置与产品培训支持等本地化服务体验"
                },
                {
                    title:'专业客服支持',
                    subtitle:"7*12小时专属客服<br/>全程在线解决您使用过程中的各类问题"
                },
                {
                    title:'强大的研发实力',
                    subtitle:"安全稳定可拷的系统支持<br/>为客户提供更智能、高效、完善的解决方案"
                }
            ]
        }
    }
}
</script>

<style lang="scss">
  :root {
    --web-max-width: 1920px;
    --web-min-width: 1300px;
  }
    #applets{
        .applets1{
            min-width:var(--web-min-width);
            // max-width:var(--web-max-width);
            margin:0 auto;
            padding-bottom: 64px;
            .title{
                font-size: 28px;
                font-weight: 400;
                color: #333333;
                padding: 60px 0 40px;
                text-align: center;
            }
            ul{
                width: 1200px;
                display: flex;
                margin:0 auto;
                text-align: center;
                li{
                    width: 286px;
                    height: 440px;
                    background: #F8F9FC;
                    border-radius: 8px 8px 8px 8px;
                    cursor: pointer;
                    .listTitle{
                        font-size: 20px;
                        font-weight: 400;
                        color: #333333;
                        margin-bottom: 20px;
                    }
                    span{
                        display: block;
                        text-align: center;
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                        margin-bottom: 12px;
                    }
                    button{
                        width: 106px;
                        height: 40px;
                        background: #0071EF;
                        border-radius: 4px 4px 4px 4px;
                        cursor: pointer;
                        font-size: 16px;
                        font-weight: 400;
                        color: #FFFFFF;
                        margin-top: 24px;
                    }
                }
                li:hover{
                    transform: translateY(-10px);
                    transition: all 0.5s;
                }
                li:nth-child(-n+3){
                    margin-right: 18px;
                }
                img{
                    width: 190px;
                }
            }
        }
        .applets2{
            min-width:var(--web-min-width);
            // max-width:var(--web-max-width);
            margin:0 auto;
            height: 780px;
            background-image: url('../../assets/applets/applets2Bg.png');
            background-size: auto 100%;
            .applets2Box{
                display: flex;
                width: 1200px;
                margin:0 auto;
                padding-top: 60px;
                .appletsLeft{
                    .appletsTitle{
                        font-size: 34px;
                        font-weight: bold;
                        color: #333333;
                        margin-bottom: 8px;
                    }
                    .appletsSubtitle{
                        font-size: 18px;
                        font-weight: 400;
                        color: #A2A5AC;
                        margin-bottom: 55px;
                    }
                    ul{
                        display: flex;
                        flex-wrap: wrap;
                        li{
                            width: 304px;
                            height: 96px;
                            background: #FFFFFF;
                            box-shadow: 0px 2px 18px 1px rgba(217,223,231,0.6);
                            border-radius: 8px 8px 8px 8px;
                            display: flex;
                            padding: 18px 0 18px 20px;
                            align-items: center;
                            cursor: pointer;
                            img{
                                width: 60px;
                                height: 60px;
                                margin-right: 16px;
                            }
                            .p1{
                                font-size: 16px;
                                font-weight: 400;
                                color: #333333;
                            }
                            .p2{
                                font-size: 14px;
                                font-weight: 400;
                                color: #A2A5AC;
                                margin-top: 4px;
                            }
                        }
                        li:nth-child(-n+7){
                            margin-bottom: 24px;
                        }
                        li:nth-child(2n-1){
                            margin-right: 24px;
                        }
                        li:hover{
                            transform: translateY(-10px);
                            transition: all 0.5s;
                        }
                    }
                }
                .appletsRight{
                    img{
                        width: 378px;
                    }
                }
            }
        }

        .applets3{
            min-width:var(--web-min-width);
            // max-width:var(--web-max-width);
            margin:0 auto;
            padding-bottom: 80px;
            .title{
                font-size: 28px;
                font-weight: 400;
                color: #333333;
                padding: 60px 0 40px;
                text-align: center;
            }
            .applets3Box{
                width: 1200px;
                margin:0 auto;
                display: flex;
                justify-content: space-between;
                .left,.right{
                    width: 550px;
                    height: 356px;
                    background: #FFFFFF;
                    box-shadow: 0px 2px 18px 1px rgba(217,223,231,0.6);
                    border-radius: 8px 8px 8px 8px;
                    overflow: hidden;
                    .BoxTitle{
                        width: 550px;
                        height: 86px;
                        background-image: url('../../assets/applets/applets3Bg.png');
                        background-size: 100% 100%;
                        font-size: 24px;
                        font-weight: 400;
                        color: #FFFFFF;
                        padding-left: 32px;
                        display: flex;
                        align-items: center;
                        margin-bottom: 36px;
                        span{
                            font-size: 20px;
                        }
                    }
                }
                .left{
                    .BoxList{
                        width: 228px;
                        height: 32px;
                        background: #F8F9FC;
                        border-radius: 100px 100px 100px 100px;
                        margin:0 auto;
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .BoxList:nth-child(-n+4){
                        margin-bottom: 24px;
                        
                    }
                }
                .right{
                    div{
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        p{
                            width: 228px;
                            height: 32px;
                            background: #F8F9FC;
                            border-radius: 100px 100px 100px 100px;
                            font-size: 14px;
                            font-weight: 400;
                            color: #666666;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        p:nth-child(-n+7){
                            margin-bottom: 24px;
                        }
                        p:nth-child(2n-1){
                            margin-right: 26px;
                        }
                    }
                }
                .center{
                    img{
                        width: 35px;
                    }
                }
            }
            .appletsBox2{
                width: 1200px;
                margin:0 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 32px;
                img{
                    width: 459.83px;
                    margin: 0 30px;
                }
                button{
                    width: 128px;
                    height: 60px;
                    background: #FFFFFF;
                    box-shadow: 0px 2px 18px 1px rgba(217,223,231,0.6);
                    border-radius: 100px 100px 100px 100px;
                    font-size: 20px;
                    font-weight: 400;
                    color: #0071EF;
                }
            }
            .appletsBox3{
                width: 1200px;
                margin:60px auto 0;
                display: flex;
                justify-content: space-between;
                li{
                    width: 380px;
                    height: 200px;
                    background: #FFFFFF;
                    box-shadow: 0px 2px 18px 1px rgba(217,223,231,0.6);
                    border-radius: 20px 20px 20px 20px;
                    padding: 40px 30px;
                    .BoxTitle{
                        font-size: 26px;
                        font-weight: bold;
                        color: #161E30;
                        margin-bottom: 42px;
                        position: relative;
                    }
                    .BoxTitle1::after{
                        content:"";
                        display: block;
                        width: 50px;
                        height: 2px;
                        background: #0071EF;
                        border-radius: 100px 100px 100px 100px;
                        position: absolute;
                        bottom: -10px;
                        left: 0;
                    }
                    .BoxTitle2::after{
                        content:"";
                        display: block;
                        width: 50px;
                        height: 2px;
                        background: #FF7733;
                        border-radius: 100px 100px 100px 100px;
                        position: absolute;
                        bottom: -10px;
                        left: 0;
                    }
                    .BoxTitle3::after{
                        content:"";
                        display: block;
                        width: 50px;
                        height: 2px;
                        background: #2BCC6F;
                        border-radius: 100px 100px 100px 100px;
                        position: absolute;
                        bottom: -10px;
                        left: 0;
                    }
                    .BoxSubtitle{
                        font-size: 14px;
                        font-weight: 400;
                        color: #161E30;
                    }
                }
            }
        }

        .applets4{
            min-width:var(--web-min-width);
            // max-width:var(--web-max-width);
            margin:0 auto;
            background: #F8F9FC;
            padding: 113px 0;
            ul{
                width: 1200px;
                margin:0 auto;
                display: flex;
                align-items: center;
                .left{
                    width: 502px;
                    margin-right: 143px;
                }
                .title{
                    font-size: 28px;
                    font-weight: bold;
                    color: #333333;
                    margin-bottom: 16px;
                }
                .subtitle{
                    font-size: 16px;
                    font-weight: 400;
                    color: #666666;
                    margin-bottom: 48px;
                }
                .button1{
                    width: 106px;
                    height: 40px;
                    background: #0071EF;
                    border-radius: 4px 4px 4px 4px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #FFFFFF;
                    margin-right: 20px;
                    cursor: pointer;
                }
                .button2{
                    width: 106px;
                    height: 40px;
                    background: #DCE9F9;
                    border-radius: 4px 4px 4px 4px;
                    opacity: 1;
                    font-size: 16px;
                    font-weight: 400;
                    color: #0071EF;
                    cursor: pointer;
                }
                img{
                    width: 555px;
                }
            }
        }
    }
</style>